export const jaReporting = {
  AdomainQuickReport: '簡易Adomainレポート',
  AdomainQuickReportDescription: 'このレポートでは、ブランドがどのようにあなたのインベントリにリーチしているかを素早く把握でき、ディールデータを重ねて各デマンドパートナーを比較し、広告主が期待通りのパフォーマンスをしているかを確認できます。',
  AdomainQuickReportPill: 'Adomainレポート',
  AdvertiserRuleReport: '広告主ルールレポート',
  AppBundleQuickReport: '簡易AppBundleレポート',
  AppBundleQuickReportDescription: 'このレポートでは、アプリ単位でのパフォーマンスを確認できます。すべての配信チャネルの状況を把握したり、アプリの連携タイプやデバイス関連のKPIを比較したりするのに役立ちます。',
  AppBundleQuickReportPill: 'AppBundleレポート',
  APSReport: 'APSレポート',
  AuctionFillRateReport: 'オークションフィルレートレポート',
  AuctionQuickReport: '簡易オークションレポート',
  AuctionQuickReportDescription: 'このレポートを実行すると、サプライ関連のデータにアクセスできます。広告枠の構成状況や、インベントリ全体における収益最適化の可能性を、主要な指標を用いてモニタリングするのに最適です。',
  AuctionQuickReportPill: 'オークションレポート',
  AuctionReport: 'オークションレポート',
  AudienceSegmentForAllPublishersReport: '全てのパブリッシャー向けオーディエンスセグメントレポート',
  AudienceSegmentLiverampReport: 'オーディエンスセグメントレポート',
  BidderQuickReport: '簡易ビダーレポート',
  BidderQuickReportDescription: 'このレポートを実行すると、デマンド関連のデータにアクセスできます。\nオークション参加に関するKPIに特化した専用の指標を使って、各ビッダーのパフォーマンスを比較するのに最適です。あわせて、アクションにつながる分析指標やエラー、レイテンシーも確認できます。',
  BidderQuickReportPill: 'ビダーレポート',
  BidderReport: 'ビダーレポート',
  BidFloorSettingReport: 'フロア価格設定レポート',
  BrandSafetyTrackerReport: 'ブランドセーフティトラッカーレポート',
  CampaignQuickReport: '簡易キャンペーンレポート',
  CampaignQuickReportDescription: 'このレポートでは、Publica Campaign Manager を通じて配信されている直販のパフォーマンスを詳しく分析できます。\nラインアイテム単位のディメンションを使って、インベントリ全体にわたるキャンペーンのKPIを追跡し、クリエイティブレベルまで掘り下げたインサイトを得ることができます。',
  CampaignQuickReportPill: 'キャンペーンレポート',
  CampaignReport: 'キャンペーンレポート',
  ContentQuickReport: '簡易コンテンツレポート',
  ContentQuickReportDescription: 'このレポートを使用すると、コンテンツレベルのディメンションで分類された収益化KPIにアクセスできます。\nインベントリを細かく確認し、最もパフォーマンスの高いジャンルやタイトルを把握することができます。',
  ContentQuickReportPill: 'コンテンツレポート',
  ContextualSegmentReport: 'コンテキストセグメントレポート',
  CreativeReviewReport: 'クリエイティブレビューレポート',
  CreativeValidationReport: 'クリエイティブ検証レポート',
  DealReport: 'ディールレポート',
  DestinationReport: 'デスティネーションレポート',
  EleaAIEnrichmentBillingReport: 'Elea AI エンリッチメント請求レポート',
  EleaAIEnrichmentReport: 'Elea AI エンリッチメントレポート',
  EleaAILanguageDetectionReport: 'Elea AI 言語検出レポート',
  EleaAIScanAllReport: 'Elea AIスキャンオールレポート',
  IASContentLevelPerformanceReport: 'IASコンテンツレベルパフォーマンスレポート',
  IASFirstPartyVASTTrackingReport: 'IAS ファーストパーティ VAST トラッキングレポート',
  IASThirdPartyVASTTrackingReport: 'IAS サードパーティ VAST トラッキングレポート',
  InventoryRouteReport: 'インベントリールートレポート',
  OutboundDealReport: 'アウトバウンドディールレポート',
  PodHourlyReport: 'ポッド時間別レポート',
  PublicaVaultJSONTrueLiftReport: 'Publica Vault JSON True Lift レポート',
  PublicaVaultTrueLiftReport: 'Publica Vault True Lift レポート',
  ReachAndFrequencyReport: 'リーチ＆フリークエンシーレポート',
  ReportingCopyQuery: 'クエリをコピー',
  ReportingEmailSubjectName: 'メールの件名',
  ReportingFilterNotEnabled: 'このレポートではフィルターが有効になっていません。',
  ReportingInputAccessPointCredentials: 'S3配信オプションを利用するには、［General Settings］でアクセスポイントの認証情報を入力してください。',
  ReportingInvestigation: '調査',
  ReportingInvestigationDescription: '調査レポートには拡張されたデータセットが含まれており、より詳細な分析が可能です。',
  ReportingLimitRows: '行数制限',
  ReportingLimitRowsDescription: '指定した行数だけ取得する場合に使用します。簡単なプレビューに便利です。',
  ReportingOrderByDescription: '選択したメトリックに基づいて、昇順または降順でレポートを並べ替えるために使用します。',
  ReportingPeriodRangeDescription: 'このレポートをスケジュール設定すると、定期的に自動で作成されます。その際の期間指定は、常に最新の日付に合わせて自動的に更新される形式になります。',
  ReportingQuery: 'クエリ',
  ReportingQueryWithAsterisk: 'クエリ *',
  ReportingQuickReports: 'クイックレポート',
  ReportingReceiveFullReport: 'レポートの全データを受け取る',
  ReportingReportName: 'レポート名',
  ReportingSelectMetricsToOrderBy: '並べ替える基準となる指標をいくつか選択してください。',
  ReportingSetUpScheduleBelow: '以下のスケジュールを設定してください',
  ReportingShareAsLink: 'リンクとして共有',
  ReportingShowingFirst5000Rows: '最初の5000行のデータを表示しています',
  ReportingShowingFullReport: '全体レポートを表示',
  ReportingSnackbarAdomainLimitRequired: 'ドメインフィルターには1～500,000の制限が必要です',
  ReportingSnackbarDownloadFailed: 'ダウンロードに失敗しました。詳細については管理者にお問い合わせください。',
  ReportingSnackbarDownloadingReport: 'レポートをダウンロードしています...',
  ReportingSnackbarEmailScheduledSuccess: '了解しました！レポートが完成したらメールでお送りします',
  ReportingSnackbarFailedToLoadLastUpdatedTimestamp: 'レポートの最終更新タイムスタンプを読み込めませんでした',
  ReportingSnackbarNameRequiredToSave: 'レポートを保存するにはレポート名が必要です',
  ReportingSnackbarSaved: 'レポートを保存しました',
  ReportingSnackbarSavedAsQuickReport: 'クイックレポートとして保存',
  ReportingSnackbarSavingReport: 'レポートを保存しています...',
  ReportingSnackbarScheduledReportNeedsRecipients: 'スケジュールされたレポートを保存するには、受信者を入力してください',
  ReportingSnackbarSchedulingReportToBeEmailed: 'レポートを電子メールで送信するようにスケジュール設定しています...',
  ReportingSnackbarSelectDimensionAndMetricToDownload: 'レポートをダウンロードするには、少なくとも 1 つのディメンションと 1 つの指標を選択してください',
  ReportingSnackbarSelectDimensionAndMetricToEmail: 'レポートをメールで送信するには、少なくとも 1 つのディメンションと 1 つの指標を選択してください',
  ReportingSnackbarSelectDimensionAndMetricToPreview: 'レポートをプレビューするには、少なくとも 1 つのディメンションと 1 つの指標を選択してください',
  ReportingSnackbarSelectDimensionAndMetricToSave: 'レポートを保存するには、少なくとも 1 つのディメンションと 1 つの指標を選択してください',
  ReportingSnackbarTheDateRangeExceedsMaximum: 'このレポートに選択できる最大日付範囲は {{count}} 日です。',
  ReportingSnackbarUnableToSaveReport: 'レポートを保存できません',
  ReportingSnackbarVenueIDRequired: '最低でも1つのVenue IDが必要です',
  ReportingSubjectNameDescription: '件名フィールドが空欄の場合、レポート名はメールの件名と同じになります。',
  ReportingTableWithAsterisk: 'テーブル *',
  ReportingTooltipDownload: '今すぐ CSV ファイルでレポートを取得します。',
  ReportingTooltipEmail: 'レポートを実行し、準備ができたらメールで送信します。レポートのサイズが大きい場合は、配信に時間がかかる場合があります。',
  ReportingTooltipFailedToCopy: 'コピーに失敗しました。ブラウザの権限を確認してください。',
  ReportingTooltipFilterState: '州フィルターは、1つの国を選択した場合にのみ機能します。',
  ReportingTooltipPreview: 'データに問題がなければ、レポートをメールでリクエストできます。まもなくお手元に届くはずです。列を並べ替えると、プレビューが自動的に更新されます。',
  ReportingTooltipPreviewNewTab: '新しいタブでレポートのデータをプレビューする',
  ReportingTooltipQuery: 'このレポートで生成されたクエリを確認します。',
  ReportingTooltipQueryCopied: 'クエリをコピーしました',
  ReportingTooltipReportReady: 'レポートはすぐにダウンロードできます。',
  ReportingTooltipTimeRange: 'クイック レポート データは 2024 年 3 月 1 日からのみ利用可能です。',
  ReportingUnableToScheduleYearToDateReport: 'YTD (年初来) レポートは、日次でのスケジュール設定には対応していません。',
  ShareOfVoiceReport: 'シェア・オブ・ボイス・レポート',
  SmartFloorsReport: 'スマートフロアレポート',
  SSAIReport: 'SSAIレポート',
  SSAIUserActivityReport: 'SSAI ユーザーアクティビティレポート',
  SSPReport: 'SSPレポート',
  ThirdPartyTrackerDomainReport: 'サードパーティトラッカードメインレポート',
  TrafficShapingReport: 'トラフィック最適化レポート',
  TTDReport: 'TTDレポート',
  UniqueUserReport: 'ユニークユーザーレポート',
  UnknownReport: '不明なレポート',
};
